import { render, staticRenderFns } from "./fundingDetails.vue?vue&type=template&id=04ac9fc4&scoped=true&"
import script from "./fundingDetails.vue?vue&type=script&lang=js&"
export * from "./fundingDetails.vue?vue&type=script&lang=js&"
import style0 from "./fundingDetails.vue?vue&type=style&index=0&id=04ac9fc4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ac9fc4",
  null
  
)

export default component.exports